import React, { useEffect, useState, useRef } from 'react';
import AdminLayout from '../Componets/AdminLayout';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function EditInternalMarks() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const location = useLocation();
  const { examId, subjectId, internalMarksId, id } = location.state || {}; // Assume internalMarksId is passed
  const [loaded, setLoaded] = useState(false);
  const focusInputRef = useRef(null); // Ref for the username input
  const [formData, setFormData] = useState({
    facultyName: '',
    name: '',
    rollNumber: '',
    subjectMarks: '',
  });
  const currentPath = location?.pathname || '';

  useEffect(() => {
    const role = localStorage.getItem('role');
    if (role !== 'ADMIN') {
      navigate('/');
    }
    focus();

    // Fetch existing internal marks data
    const token = localStorage.getItem('token');
    axios
      .get(`${apiUrl}/api/internalmarks/${id}`, {
        headers: { Authorization: token },
      })
      .then((res) => {
        const { facultyName, name, rollNumber, subjectMarks } = res.data;
        setFormData({
          facultyName,
          name,
          rollNumber,
          subjectMarks,
        });
      })
      .catch((err) => {
        console.error('Error fetching internal marks:', err);
        toast.error('Error fetching internal marks data');
        err.response?.status === 401 && navigate('/');
      });
  }, [apiUrl, navigate, internalMarksId]);

  const focus = () => {
    if (focusInputRef.current) {
      focusInputRef.current.focus();
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    setLoaded(true);

    const token = localStorage.getItem('token');

    // Make a PUT request to update internal marks
    axios
      .put(
        `${apiUrl}/api/internalmarks/${id}`,
        {
          examId,
          subjectId,
          ...formData,
        },
        {
          headers: {
            Authorization: `${token}`,
            'Content-Type': 'application/json',
          },
        }
      )
      .then((res) => {
        toast.success('Internal marks updated successfully');
        focus();
        setLoaded(false);
        if (currentPath === '/EditInternalMarks') {
          const timeOutDuration = 3000;
          const timeoutId = setTimeout(() => {
            if (window.location.pathname === '/EditInternalMarks') {
              navigate(-1);
            }
          }, timeOutDuration);
          return () => clearTimeout(timeoutId);
        }
      })
      .catch((err) => {
        console.error('Error updating internal marks:', err);
        toast.error(
          err.response?.data?.message || 'Error updating internal marks'
        );
        setLoaded(false);
        err.response?.status === 401 && navigate('/');
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: name === 'subjectMarks' ? Number(value) : value,
    }));
  };

  return (
    <>
      <AdminLayout ac7="active">
        <main id="main" className="main">
          <div className="pagetitle">
            <nav>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/AdminHome">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <span className="cursor-pointer" onClick={() => navigate(-3)}>
                    Exams for Internal Marks
                  </span>
                </li>
                <li className="breadcrumb-item">
                  <span className="cursor-pointer" onClick={() => navigate(-2)}>
                    Subject list
                  </span>
                </li>

                <li
                  className="breadcrumb-item cursor-pointer"
                  onClick={() => navigate(-1)}
                >
                  Internal Marks
                </li>
                <li className="breadcrumb-item active">Edit Internal Marks</li>
              </ol>
            </nav>
          </div>
          <section className="section col-lg-112">
            <div className="row">
              <div className="">
                <div className="card">
                  <div className="card-body mt-5 mx-3">
                    <form onSubmit={handleSubmit}>
                      <div className="container">
                        <div className="row row-cols-1">
                          <div className="col-6">
                            <div className="form-floating mb-2">
                              <input
                                className="form-control"
                                type="text"
                                name="rollNumber"
                                value={formData.rollNumber}
                                onChange={handleChange}
                                placeholder="Roll Number"
                                required
                                disabled
                              />
                              <label className="form-label">
                                Roll Number{' '}
                                <span className="text-danger">*</span>
                              </label>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="form-floating mb-2">
                              <input
                                className="form-control"
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                placeholder="Student Name"
                                required
                                disabled
                              />
                              <label className="form-label">
                                Student Name{' '}
                                <span className="text-danger">*</span>
                              </label>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="form-floating mb-2">
                              <input
                                ref={focusInputRef}
                                className="form-control"
                                type="text"
                                name="facultyName"
                                value={formData.facultyName}
                                onChange={handleChange}
                                placeholder="Faculty Name"
                                required
                              />
                              <label className="form-label">
                                Faculty Name{' '}
                                <span className="text-danger">*</span>
                              </label>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="form-floating mb-2">
                              <input
                                className="form-control"
                                type="number"
                                name="subjectMarks"
                                value={formData.subjectMarks}
                                onChange={handleChange}
                                placeholder="Subject Marks"
                                required
                                min={0}
                                onWheel={(e) => e.target.blur()}
                              />
                              <label className="form-label">
                                Subject Marks{' '}
                                <span className="text-danger">*</span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12 pt-4 text-end">
                          <button
                            type="button"
                            className="btn btn-primary px-3"
                            onClick={() => navigate(-1)}
                          >
                            <i className="bi bi-arrow-bar-left"></i> Back
                          </button>
                          <button
                            type="submit"
                            className="btn btn-primary px-4 mx-2"
                            disabled={loaded}
                          >
                            {loaded ? (
                              <>
                                <span
                                  className="spinner-border spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>{' '}
                                Wait...
                              </>
                            ) : (
                              <>Save</>
                            )}
                          </button>
                        </div>
                      </div>
                    </form>
                    <ToastContainer
                      position="top-center"
                      style={{ width: 'auto' }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
      </AdminLayout>
    </>
  );
}
